import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import API_URL from './config/apiConfig';
import { loadGoogleMaps } from './utils/loadGoogleMaps';


export const server = API_URL;

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = () => root.render(
  <React.StrictMode>
    <App />
    {/* <Toaster richColors position="top-center"/> */}
  </React.StrictMode>
);

// Preserve the existing SDK-before-React initialization order. Other pages
// remain usable if Maps billing/network is unavailable.
loadGoogleMaps().catch(() => console.warn("Maps is temporarily unavailable")).finally(renderApp);
